/* eslint-disable */
const btoa = require('btoa');
import axios from 'axios';

// Cached fetches from the server's /config/:key endpoint. The server hydrates
// these from AWS SSM at boot, so they aren't baked into the JS bundle.
let _clientCredsPromise;

const loadClientCreds = () => {
    if (_clientCredsPromise) return _clientCredsPromise;
    _clientCredsPromise = (async () => {
        const [idMyRes, secretMyRes, idBnRes, secretBnRes] = await Promise.all([
            fetch('/config/CLIENT_ID_MY').then(r => r.json()),
            fetch('/config/CLIENT_SECRET_MY').then(r => r.json()),
            fetch('/config/CLIENT_ID_BN').then(r => r.json()),
            fetch('/config/CLIENT_SECRET_BN').then(r => r.json()),
        ]);
        return {
            CLIENT_ID_MY: idMyRes.value,
            CLIENT_SECRET_MY: secretMyRes.value,
            CLIENT_ID_BN: idBnRes.value,
            CLIENT_SECRET_BN: secretBnRes.value,
        };
    })();
    return _clientCredsPromise;
};

const getConfig = async (currentPath) => {
    const creds = await loadClientCreds();

    let tokenUrl
    let redirectUri
    let clientId
    let clientSecret

    if (process.env.REACT_APP_LOGIN_ENV === "dev" || process.env.REACT_APP_LOGIN_ENV === "uat") {
        tokenUrl = "https://gluu-preprod01-qaapac.amstack-amwayidv2-preprod.amwayglobal.com/oxauth/restv1/token"
    } else if (process.env.REACT_APP_LOGIN_ENV === "psup") {
        tokenUrl = "https://gluu-preprod01-perf.amstack-amwayidv2-preprod.amwayglobal.com/oxauth/restv1/token"
    } else if (process.env.REACT_APP_LOGIN_ENV === "prod") {
        tokenUrl = "https://gluu-prod01-prod.amstack-amwayidv2-prod.amwayglobal.com/oxauth/restv1/token"
    }

    if (currentPath === 'uat.healthscreening.amway.my' || currentPath === 'healthscreening.amway.my') {
        redirectUri = process.env.REACT_APP_LOGIN_ENV === "uat" ? "https://uat.healthscreening.amway.my/oauth/authorize/" : "https://healthscreening.amway.my/oauth/authorize/";
        clientId = creds.CLIENT_ID_MY;
        clientSecret = creds.CLIENT_SECRET_MY;

    }else if (currentPath === 'uat.healthscreening.amway.com.bn' || currentPath === 'healthscreening.amway.com.bn') {
        redirectUri = process.env.REACT_APP_LOGIN_ENV === "uat" ? "https://uat.healthscreening.amway.com.bn/oauth/authorize/" : "https://healthscreening.amway.com.bn/oauth/authorize/";
        clientId = creds.CLIENT_ID_BN;
        clientSecret = creds.CLIENT_SECRET_BN;

    } else if (currentPath === 'psup.healthscreening.amway.my') {
        redirectUri = "https://psup.healthscreening.amway.my/oauth/authorize/";
        clientId = creds.CLIENT_ID_MY;
        clientSecret = creds.CLIENT_SECRET_MY;

    } else if (currentPath === 'psup.healthscreening.amway.com.bn') {
        redirectUri = "https://psup.healthscreening.amway.com.bn/oauth/authorize/";
        clientId = creds.CLIENT_ID_BN;
        clientSecret = creds.CLIENT_SECRET_BN;

    } else if (currentPath === 'localhost') {
        redirectUri = "https://uat.healthscreening.amway.my/oauth/authorize/";
        clientId = creds.CLIENT_ID_MY;
        clientSecret = creds.CLIENT_SECRET_MY;

    }

    return {tokenUrl,redirectUri,clientId,clientSecret}
}

const getClientSecretBasic = (client_id,client_secret) => {
    return btoa(`${client_id}:${client_secret}`);
};


// const toFormBody = (data) => {
// 	let formBody = [];
// 	for (const property in data) {
// 		formBody.push(`${encodeURIComponent(property)}=${encodeURIComponent(data[property])}`);
// 	}
// 	return formBody.join('&');
// };

const toFormBody = (data) => new URLSearchParams(data).toString();

export const requestToken = async (params) => {

    let hostname = params.hostname
    let {tokenUrl,redirectUri,clientId,clientSecret} = await getConfig(hostname)

    let authorization_code = params?.code
    const data = {
        grant_type: 'authorization_code',
        redirect_uri: redirectUri,
        code: authorization_code
    };

    let header = {
        Authorization: `Basic ${getClientSecretBasic(clientId,clientSecret)}`,
        'Content-Type': 'application/x-www-form-urlencoded',
        }

    let result;

    try {
        const response = await fetch(tokenUrl, {
            method: "POST",
            headers: header,
            body: new URLSearchParams(data).toString(), // Convert data to form-encoded format
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const resData = await response.json(); // Parse JSON response
          console.log("Token Response:", resData);
          result = resData.refresh_token; // Extract the refresh token if needed
    } catch (error) {
        console.log("See request token error:", error.response?.data || error.message);
        result = error.response?.data || error.message; // Handle error response
    }

    return result; // Return the result

};

export const requestRefreshToken = async (params) => {

    let hostname = params.hostname
    let aboId = params.aboId
    let affCode = params.affCode

    let {tokenUrl,redirectUri,clientId,clientSecret} = await getConfig(hostname)

    let refreshToken = params.refreshToken
    const data = {
        grant_type: 'authorization_code',
        redirect_uri: redirectUri,
        code: refreshToken,
    };

    let header = {
        Authorization: `Basic ${getClientSecretBasic(clientId,clientSecret)}`,
        'Content-Type': 'application/x-www-form-urlencoded',
        }

    let result
    try {
        result = await refreshTokenAPI(refreshToken,aboId,affCode,hostname)

        console.log("See refresh token data:", result);
        return result;
    }
    catch(error) {
        console.log("See refresh token error:", error.response?.data || error.message);
        result = error?.response?.data

        return result
    }

};

const refreshTokenAPI = async (refreshToken, aboId, affCode, hostname) => {

    let {tokenUrl,redirectUri,clientId,clientSecret} = await getConfig(hostname)

    const data = {
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        scope: 'openid profile abo abo_name accounts_details_profile offline_access account_profile bonus:all:read mdms:accounts:read'
        };


    let header = {
        Authorization: `Basic ${getClientSecretBasic(clientId,clientSecret)}`,
        'Content-Type': 'application/x-www-form-urlencoded',
        }
    let result;

    try {
        // const resp2 = await axios.post(
        //     `${tokenUrl}?salesPlanAff=${affCode}&aboNumber=${aboId}`,
        //     toFormBody(data),
        //     {
        //         headers: header,
        //     }
        // );

        // // Assign the response data to `result`
        // result = resp2?.data;
        const response = await fetch(`${tokenUrl}?salesPlanAff=${affCode}&aboNumber=${aboId}`, {
            method: "POST",
            headers: header,
            body: new URLSearchParams(data).toString(), // Convert data to form-encoded format
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const resData = await response.json(); // Parse JSON response
          result = resData; // Extract the refresh token if needed
    } catch (error) {
        // Assign the error response data to `result`
        result = error?.response?.data;
    }

    // Return the result after the request completes
    return result;
};
